import { defineComponent as r, computed as t, openBlock as c, createBlock as p, resolveDynamicComponent as a } from "vue";
import { flags as s } from "./novoui-vuejs48.js";
const i = /* @__PURE__ */ r({
  __name: "NFlag",
  props: {
    country: {
      type: String,
      required: !1
    }
  },
  setup(o) {
    const e = o, n = t(() => e.country ? s[e.country] : null);
    return (u, l) => (c(), p(a(n.value), { class: "flag" }));
  }
});
export {
  i as default
};
